class KmCartCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.track = this.querySelector('.km-cart-bestsellers__grid');
    this.previous = this.querySelector('.km-cart-carousel__arrow--prev');
    this.next = this.querySelector('.km-cart-carousel__arrow--next');
    this.previous.setAttribute('aria-controls', this.track.id);
    this.next.setAttribute('aria-controls', this.track.id);
    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.track);
    this.update();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
  move(direction) {
    const card = this.track.firstElementChild;
    if (!card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
    this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  update() {
    this.previous.disabled = this.track.scrollLeft <= 2;
    this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
  }
}
if (!customElements.get('km-cart-carousel')) customElements.define('km-cart-carousel', KmCartCarousel);
